// In the thread: a design Chat saved for a store's shopping assistant, like an App's card. It names the version
// (a draft, not live) and opens the storefront canvas beside the chat.
import { formatCopy, useNamespaceCopy } from '@/i18n/ns';
import storefrontCopy from '@/i18n/ns/storefront';
import { useOptionalWorkspace } from '../context';
import { WorkspaceIcon } from '../icons';

type SavedDesign = {
  status?: string;
  version?: number | null;
  store?: { id?: string; name?: string };
};

export function StorefrontDesignCard({
  result,
  incomplete,
}: {
  result?: unknown;
  incomplete?: boolean;
}) {
  const ws = useOptionalWorkspace();
  const copy = useNamespaceCopy(storefrontCopy);
  const saved = result && typeof result === 'object' ? (result as SavedDesign) : null;
  if (!saved)
    return (
      <div className="ws-tool-progress" role="status">
        <WorkspaceIcon name="clock" size={14} />
        {incomplete ? copy.designUnconfirmed : copy.designSaving}
      </div>
    );
  const store = saved.store;
  // A refused or failed change is the chat's to explain; there is no saved version to open.
  if (saved.status !== 'ok' || typeof store?.id !== 'string' || !ws) return null;
  const storeId = store.id;
  return (
    <button
      type="button"
      className="ws-artifact-card sf-design-card"
      data-testid="sf-design-card"
      onClick={() => ws.openCanvas({ kind: 'storefront', id: storeId })}
    >
      <WorkspaceIcon name="store" size={22} />
      <span>
        <b>{formatCopy(copy.designCardTitle, { name: store.name ?? '' })}</b>
        <small>
          {saved.version
            ? formatCopy(copy.designCardSaved, { version: String(saved.version) })
            : copy.designCardSavedFirst}
        </small>
      </span>
      <WorkspaceIcon name="arrow" size={15} />
    </button>
  );
}
